import category from './category';
import animateProductGridBannerText from './productGridBanner';
import renderLargeProductCard from './largeProductCard';
import sortCustomDropdown from './sortCustomDropdown';
import filterCustomDropdown from './filterCustomDropdown';
import filterSortBarLayout from './filterSortBarLayout';
import searchBarClose from './searchBarClose';
import handleColumnLayout from './columnSwitcher';

// run all related funcs here
const runFuncs = () => {
  category();
  animateProductGridBannerText();
  renderLargeProductCard();
  sortCustomDropdown();
  filterCustomDropdown();
  filterSortBarLayout();
  searchBarClose();
  handleColumnLayout();
};

export default runFuncs;
